










































import Vue from 'vue'
import { NearStoresLinkElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'NearStoresLinkEl',

  data: () => ({
    overlay: false
  }),

  props: {
    templateItemData: {
      type: Object as () => NearStoresLinkElInterface,
      required: true
    }
  },

  methods: {
    getUserLocation (): void {
      this.overlay = true
      const { view, uri } = this.$props.templateItemData
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords
          this.$store.dispatch('commitUserLocation', { latitude, longitude })
          this.overlay = false
          this.getView(view, uri)
        },
        () => {
          this.overlay = false
          this.getView(view, uri)
        }
      )
    }
  }
})
